import {
  Component, OnInit, ChangeDetectorRef, OnDestroy
} from '@angular/core';
import AccountService from 'app/core/auth/account.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import PharmacyLocationsRxService from './pharmacy-locations-rx.service';

@Component({
  selector: 'jhi-pharmacy-locations-rx',
  templateUrl: './pharmacy-locations-rx.component.html',
  styleUrls: ['pharmacy-locations-rx.scss']
})
export default class PharmacyLocationsRxComponent implements OnInit, OnDestroy {
  private pharmacyLocationsRxComponent$: Subject<void> = new Subject<void>();

  previous: any;

  origin: any;

  destination: any;

  pharmacies: any;

  isPharmacyDetails: boolean;

  selectedPharmacy: any;

  imagesList: any;

  loader: boolean;

  slideScreen;

  constructor(
    private pharmacyLocationsService: PharmacyLocationsRxService,
    private accountService: AccountService
  ) {
    this.pharmacies = [];
    this.isPharmacyDetails = false;
    this.imagesList = [];
  }

  ngOnInit() {
    this.accountService.slideScreen.pipe(takeUntil(this.pharmacyLocationsRxComponent$)).subscribe((data) => {
      this.slideScreen = data;
    });

    this.getPharmacies();
  }

  getPharmacies() {
    this.loader = true;
    this.pharmacyLocationsService
      .getPharmacies()
      .pipe(takeUntil(this.pharmacyLocationsRxComponent$))
      .subscribe((resp) => {
        if (resp) {
          this.pharmacies = resp;
          this.pharmacies = this.pharmacies.sort(this.pharmacySort);
          this.pharmacies.forEach((element) => {
            const address = [];
            const addressInfo = [];
            element.images = element.imageUrl ? element.imageUrl.split(',') : '';
            if (element.pharmacyWeeklySchedule) {
              element.pharmacyWeeklySchedule = JSON.parse(element.pharmacyWeeklySchedule);
              element.hours = element.pharmacyWeeklySchedule;
            }
            if (element.streetAddress !== '') {
              address.push(element.streetAddress);
            }

            if (element.addressLocality !== '') {
              address.push(element.addressLocality);
            }

            if (element.addressRegion !== '') {
              address.push(`${element.addressRegion} ${element.postalCode}`);
            }

            if (element.landmark !== '') {
              addressInfo.push(element.landmark);
            }

            if (element.additionalLocationInfo !== null) {
              addressInfo.push(element.additionalLocationInfo);
            }

            element.address = address.join(', ');
            element.addressInfo = addressInfo.join(', ');
          });
          this.loader = false;
        }
      });
  }

  viewPharmacyDetails(data) {
    this.imagesList = [];
    this.selectedPharmacy = data;
    if (this.selectedPharmacy.imageUrl) {
      for (let i = 0; i < this.selectedPharmacy.images.length; i++) {
        this.pharmacyLocationsService
          .getPharmacyImage(
            this.selectedPharmacy.pharmacyId,
            this.selectedPharmacy.images[i] === '' ? 'no-image.jpg' : this.selectedPharmacy.images[i]
          )
          .pipe(takeUntil(this.pharmacyLocationsRxComponent$))
          .subscribe((resp) => {
            if (resp) {
              this.blobToImg(resp);
            }
          });
      }
    }

    setTimeout(() => {
      this.isPharmacyDetails = true;
    }, 200);
  }

  blobToImg(blob: Blob) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.imagesList = this.imagesList.concat(reader.result);
      },
      false
    );
    if (blob) {
      reader.readAsDataURL(blob);
    }
  }

  back() {
    this.isPharmacyDetails = false;
  }

  private pharmacySort(a: any, b: any): number {
    return a.name.localeCompare(b.name);
  }

  public ngOnDestroy(): void {
    this.pharmacyLocationsRxComponent$.next();
    this.pharmacyLocationsRxComponent$.unsubscribe();
  }
}
